import apiClient from '../../../api/client';
import type {
  TipoServicioResponse,
  CreateTipoServicioDto,
  UpdateTipoServicioDto,
  QueryTiposServicioDto,
  Paginated,
} from '@aid/shared';

export type {
  TipoServicioResponse,
  CreateTipoServicioDto,
  UpdateTipoServicioDto,
  QueryTiposServicioDto,
};

export async function getTiposServicio(
  params: QueryTiposServicioDto,
): Promise<Paginated<TipoServicioResponse>> {
  const { data } = await apiClient.get<Paginated<TipoServicioResponse>>('/admin/tipos-servicio', {
    params,
  });
  return data;
}

export async function getTipoServicio(id: number): Promise<TipoServicioResponse> {
  const { data } = await apiClient.get<TipoServicioResponse>(`/admin/tipos-servicio/${id}`);
  return data;
}

export async function createTipoServicio(
  dto: CreateTipoServicioDto,
): Promise<TipoServicioResponse> {
  const { data } = await apiClient.post<TipoServicioResponse>('/admin/tipos-servicio', dto);
  return data;
}

export async function updateTipoServicio(
  id: number,
  dto: UpdateTipoServicioDto,
): Promise<TipoServicioResponse> {
  const { data } = await apiClient.patch<TipoServicioResponse>(`/admin/tipos-servicio/${id}`, dto);
  return data;
}

export async function deleteTipoServicio(id: number): Promise<void> {
  await apiClient.delete(`/admin/tipos-servicio/${id}`);
}
